<template>
  <li class="kds-panels-list-row">
    <span class="kds-panels-list-row__code">{{ code }}</span>
    <span class="kds-panels-list-row__name">{{ name }}</span>
    <span class="kds-panels-list-row__meta">{{ meta }}</span>
    <KdsBadge :tone="status === 'live' ? 'live' : 'muted'">
      {{ status }}
    </KdsBadge>
  </li>
</template>

<script setup lang="ts">
import KdsBadge from '@/kds/primitives/KdsBadge.vue';

interface Props {
  code: string;
  name: string;
  meta: string;
  status: 'live' | 'paused' | 'draft' | 'closed';
}

defineProps<Props>();
</script>

<style scoped lang="scss">
.kds-panels-list-row {
  display: grid;
  grid-template-columns: 80px 1fr 1fr auto;
  align-items: center;
  gap: var(--space-4);
  padding: var(--space-4) var(--space-5);
  border-bottom: var(--border);

  &__code {
    font-family: var(--font-mono);
    font-size: var(--fs-mono);
    color: var(--stone);
  }

  &__name {
    color: var(--ink);
    font-size: var(--fs-body);
    font-weight: var(--fw-medium);
  }

  &__meta {
    color: var(--stone);
    font-size: var(--fs-body-sm);
  }
}
</style>
